import React from "react"
import "./SelfTestResult.scss"
import $ from "jquery"
import { UrlService } from "../../../../core/services/UrlService"
import { SVGRestart } from "../../../../assets/icons/SVGRestart"
import { TrackingService } from "../../../../core/services/TrackingService"

const SelfTestResult: React.FC<any> = (props: any) => {
    React.useEffect(() => {
        $("html, body").animate(
            {
                scrollTop: $(".self-test-result").position()?.top - 40 || 0,
            },
            500
        )
    }, [])

    const slug = "covid22"

    const resultText = React.useMemo(() => {
        switch (props.result) {
            case "Yellow":
                return "danger"
            case "Blue":
                return "high"
            case "Green":
                return "small"
            case "Purple":
                return "mild"
            default:
                return ""
        }
    }, [props.result])

    React.useEffect(() => {
        if (resultText) {
            TrackingService.trackSelftest(slug, `result`, resultText)
        }
    }, [resultText])

    const handleSrpTrack = React.useCallback(() => {
        TrackingService.trackSelftest(slug, `srp`, resultText)
    }, [resultText])

    const handle999Track = React.useCallback(() => {
        TrackingService.trackSelftest(slug, `999`, resultText)
    }, [resultText])

    const srpLinkWithITM = React.useMemo(() => {
        return UrlService.getBaseUrl(
            `/doctors/covid22?itm_campaign=${slug}&itm_source=srp-risk_${resultText}&itm_medium=self-test`
        )
    }, [resultText])

    return (
        <section>
            <div className="self-test-result">
                {(() => {
                    switch (props.result) {
                        case "Yellow":
                            return (
                                <div className="js-result-content">
                                    <div className="self-test-results-content">
                                        <div className="self-test-results-content_image">
                                            <img
                                                className="self-test-result-img"
                                                src={UrlService.getLocalImageUrl(
                                                    "self-test/covid/result2.png?1"
                                                )}
                                            />
                                        </div>
                                        <p className="self-test-results-content_text">
                                            您已出現警告症狀，請盡早到公立醫院急症室求診，告知醫護⼈員您出現2019新型冠狀病毒的警告症狀，並根據指引接受進⼀步治療
                                            <sup>4</sup>。
                                            <div className="self-test-results-footer">
                                                <div className="self-test-results-footer-restart-container">
                                                    <span className="self-test-button ">
                                                        <a
                                                            className="self-test-button_label buttom-label1"
                                                            href={UrlService.preserveQuery(
                                                                "/self-test/covid"
                                                            )}
                                                        >
                                                            <SVGRestart />
                                                            &nbsp; 重新評估
                                                        </a>
                                                    </span>
                                                    <span className="self-test-button">
                                                        <a
                                                            className="self-test-button_label buttom-label3 setMargin"
                                                            href="tel:999"
                                                            onClick={
                                                                handle999Track
                                                            }
                                                        >
                                                            致電999
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            )
                        case "Blue":
                            return (
                                <div className="js-result-content">
                                    <div className="self-test-results-content">
                                        <div className="self-test-results-content_image">
                                            <img
                                                className="self-test-result-img"
                                                src={UrlService.getLocalImageUrl(
                                                    "self-test/covid/result3.png?1"
                                                )}
                                            />
                                        </div>
                                        <p className="self-test-results-content_text">
                                            根據您的回答，您感染2019新型冠狀病毒的機會相對較⾼，特別是老⼈家和患有其他醫療問題的⼈更容易轉爲重病<sup>5</sup>。建議盡快尋求醫⽣作進⼀步評估及治療。
                                            <br />
                                            <br />
                                            現有259位私家醫⽣可替合適的新冠病⼈處⽅及免費提供新冠⼝服抗病毒藥物。
                                            <p className="mini">
                                                請留意，新冠肺炎口服藥現由政府資助，但您仍需自付診金或額外藥物費用。
                                            </p>
                                            <div className="self-test-results-footer">
                                                <div className="self-test-results-footer-restart-container">
                                                    <span className="self-test-button ">
                                                        <a
                                                            className="self-test-button_label buttom-label1"
                                                            href={UrlService.preserveQuery(
                                                                "/self-test/covid"
                                                            )}
                                                        >
                                                            <SVGRestart />
                                                            &nbsp; 重新評估
                                                        </a>
                                                    </span>
                                                    <span className="self-test-button">
                                                        <a
                                                            className="self-test-button_label buttom-label2 setMargin"
                                                            href={
                                                                srpLinkWithITM
                                                            }
                                                            onClick={
                                                                handleSrpTrack
                                                            }
                                                        >
                                                            私家醫⽣名單
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            )
                        case "Green":
                            return (
                                <div className="js-result-content">
                                    <div className="self-test-results-content">
                                        <div className="self-test-results-content_image">
                                            <img
                                                className="self-test-result-img"
                                                src={UrlService.getLocalImageUrl(
                                                    "self-test/covid/result1.png?1"
                                                )}
                                            />
                                        </div>
                                        <p className="self-test-results-content_text">
                                            因應⽬前2019新型冠狀病毒爆發之狀況，為保障您和您家⼈的健康，請盡早到以下診所求診，再根據醫護⼈員指引接受進⼀步化驗及治療。
                                            <div className="self-test-results-footer">
                                                <div className="self-test-results-footer-restart-container">
                                                    <span className="self-test-button ">
                                                        <a
                                                            className="self-test-button_label buttom-label1"
                                                            href={UrlService.preserveQuery(
                                                                "/self-test/covid"
                                                            )}
                                                        >
                                                            <SVGRestart />
                                                            &nbsp; 重新評估
                                                        </a>
                                                    </span>
                                                    <a className="self-test-button">
                                                        <a
                                                            className="self-test-button_label buttom-label2 setMargin"
                                                            href={
                                                                srpLinkWithITM
                                                            }
                                                            onClick={
                                                                handleSrpTrack
                                                            }
                                                        >
                                                            私家醫⽣名單
                                                        </a>
                                                    </a>
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            )
                        case "Purple":
                            return (
                                <div className="js-result-content">
                                    <div className="self-test-results-content">
                                        <div className="self-test-results-content_image">
                                            <img
                                                className="self-test-result-img"
                                                src={UrlService.getLocalImageUrl(
                                                    "self-test/covid/result4.png?1"
                                                )}
                                            />
                                        </div>
                                        <p className="self-test-results-content_text">
                                            您感染2019新型冠狀病毒的機會較微，不過但凡⾝體出現任何不適，亦應盡快向醫⽣徵詢意⾒，以免病情惡化，甚⾄傳染給⾝邊的⼈。
                                            <br />
                                            <br />
                                            現有259位私家醫⽣可替合適的新冠病⼈處⽅及免費提供新冠⼝服抗病毒藥物。
                                            <p className="mini">
                                                請留意，新冠肺炎口服藥現由政府資助，但您仍需自付診金或額外藥物費用。
                                            </p>
                                            <div className="self-test-results-footer">
                                                <div className="self-test-results-footer-restart-container">
                                                    <span className="self-test-button ">
                                                        <a
                                                            className="self-test-button_label buttom-label1"
                                                            href={UrlService.preserveQuery(
                                                                "/self-test/covid"
                                                            )}
                                                        >
                                                            <SVGRestart />
                                                            &nbsp; 重新評估
                                                        </a>
                                                    </span>
                                                    <span className="self-test-button">
                                                        <a
                                                            className="self-test-button_label buttom-label2 setMargin"
                                                            href={
                                                                srpLinkWithITM
                                                            }
                                                            onClick={
                                                                handleSrpTrack
                                                            }
                                                        >
                                                            私家醫⽣名單
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            )
                    }
                })()}
            </div>
        </section>
    )
}

export default SelfTestResult
